<div class="analysis-details">

    <!-- Left side -->
    <div class="analysis-details-left-side" id="analysis-details-pdf">
        <mat-card>
            <mat-card-header class="p-2">
                <div class="card-header">
                    <div class="pressures-title">
                        <mat-card-title>{{ 'ANALYSIS_DETAILS' | translate }}</mat-card-title>
                    </div>
                    <div class="generate-details-pdf">
                        <div class="d-flex flex-column gap-3">
                            <div class="badges">
                                <span class="btn features-button btn-circle btn-md">{{ premiumUser ? 'PRO PLAN' : 'BASIC
                                    PLAN' }}</span>
                                <button *ngIf="!premiumUser" type="button" mat-raised-button color="primary"
                                    (click)="openUpgradeModal()">UPGRADE</button>
                                <app-modal-pro-features [(visible)]="upgradeModalVisible"></app-modal-pro-features>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-header>

            <!-- Skeleton -->
            <div class="d-flex justify-content-center mb-5" *ngIf="isLoading">
                <div class="skeleton-card is-loading">
                    <div class="image"></div>
                    <div class="content">
                        <h2></h2>
                        <p></p>
                        <div class="d-flex justify-content-end w-100">
                            <h2></h2>
                        </div>
                    </div>
                </div>
            </div>

            <mat-card-content *ngIf="analysis" class="p-3">
                <div class="card-body">
                    <div class="detailed-mini-card">
                        <div class="card-body">
                            <div class="card-body-top">
                                <h5
                                    class="btn-rounded btn-block analysis-card-body-top m-2 width-120 text-align-center badge">
                                    <strong>{{
                                        'ANALYSIS_TYPE.'
                                        + analysis.type | translate }}</strong>
                                </h5>
                                <h5 class="m-3"> {{ analysis.creationDate }}</h5>
                            </div>

                            <!-- Static -->
                            <div *ngIf="analysis.type === 'Static'">
                                <div class="analysis-details-full-container">
                                    <div
                                        style="min-width: 200px; padding-left: 50px; display: flex; align-items: center;">
                                        <app-analysis #analysisComponent [showActions]="showActions"
                                            [analysis]="analysis"></app-analysis>
                                    </div>
                                    <div *ngIf="premiumUser" class="analysis-details-main-container">
                                        <div class="card-body-bottom">
                                            <h5
                                                class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                                <strong>{{ 'FOOT_LENGTH' | translate }}</strong>
                                            </h5>
                                            <div class="analysis-details-container">
                                                <div class="analysis-card-details">
                                                    <img class="analysis-details-image"
                                                        src="assets/images/analysis/foot-length.png"
                                                        alt="{{ 'FOOT_LENGTH' | translate }}">
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.left.length }}cm</span>
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.right.length }}cm</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body-bottom">
                                            <h5
                                                class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                                <strong>{{ 'FOREFOOT_WIDTH' | translate }}</strong>
                                            </h5>
                                            <div class="analysis-details-container">
                                                <div class="analysis-card-details">
                                                    <img class="analysis-details-image"
                                                        src="assets/images/analysis/forefoot-width.png"
                                                        alt="{{ 'FOREFOOT_WIDTH' | translate }}">
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.left.width.forefoot
                                                        }}cm</span>
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.right.width.forefoot
                                                        }}cm</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body-bottom">
                                            <h5
                                                class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                                <strong>{{ 'REARFOOT_WIDTH' | translate }}</strong>
                                            </h5>
                                            <div class="analysis-details-container">
                                                <div class="analysis-card-details">
                                                    <img class="analysis-details-image"
                                                        src="assets/images/analysis/rearfoot-width.png"
                                                        alt="{{ 'REARFOOT_WIDTH' | translate }}">
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.left.width.rearfoot
                                                        }}cm</span>
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.right.width.rearfoot
                                                        }}cm</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body-bottom">
                                            <h5
                                                class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                                <strong>{{ 'WEIGHT_DISTRIBUTION' | translate }}</strong>
                                            </h5>
                                            <div class="analysis-details-container">
                                                <div class="analysis-card-details">
                                                    <img class="analysis-details-image"
                                                        src="assets/images/analysis/weight-distribution.png"
                                                        alt="{{ 'WEIGHT_DISTRIBUTION' | translate }}">
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                    <span>{{
                                                        analysisComponent.feetAnalysis.left.stats.weightDistributionInPercentage
                                                        }}%</span>
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                    <span>{{
                                                        analysisComponent.feetAnalysis.right.stats.weightDistributionInPercentage
                                                        }}%</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body-bottom">
                                            <h5
                                                class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                                <strong>{{ 'FOOT_AREA' | translate }}</strong>
                                            </h5>
                                            <div class="analysis-details-container">
                                                <div class="analysis-card-details">
                                                    <img class="analysis-details-image"
                                                        src="assets/images/analysis/foot-area.png"
                                                        alt="{{ 'FOOT_AREA' | translate }}">
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.left.stats.footArea
                                                        }}cm²</span>
                                                </div>
                                                <div class="analysis-card-details">
                                                    <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                    <span>{{ analysisComponent.feetAnalysis.right.stats.footArea
                                                        }}cm²</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!generatingPDF && premiumUser" class="generate-details-pdf">
                                    <span>{{ 'ANALYSIS_DETAILS' | translate }}</span>
                                    <button mat-raised-button class="pdf-special-button"
                                        (click)="generateAnalysisDetailsPDF()">
                                        <i class="pi pi-file-pdf"></i> </button>
                                </div>
                            </div>
                            <!-- Dynamic -->
                            <div *ngIf="analysis.type === 'Dynamic'">
                                <app-analysis #analysisComponent [showActions]="showActions" [analysis]="analysis"
                                    [orderData]="order.data" [generatingPDF]="generatingPDF"></app-analysis>
                                <div *ngIf="premiumUser" class="analysis-details-main-container">
                                    <div class="card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'FOOT_LENGTH' | translate }}</strong>
                                        </h5>
                                        <div class="analysis-details-container">
                                            <div class="analysis-card-details">
                                                <img class="analysis-details-image"
                                                    src="assets/images/analysis/foot-length.png"
                                                    alt="{{ 'FOOT_LENGTH' | translate }}">
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.left.length }}cm</span>
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.right.length }}cm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'FOREFOOT_WIDTH' | translate }}</strong>
                                        </h5>
                                        <div class="analysis-details-container">
                                            <div class="analysis-card-details">
                                                <img class="analysis-details-image"
                                                    src="assets/images/analysis/forefoot-width.png"
                                                    alt="{{ 'FOREFOOT_WIDTH' | translate }}">
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.left.width.forefoot }}cm</span>
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.right.width.forefoot }}cm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'REARFOOT_WIDTH' | translate }}</strong>
                                        </h5>
                                        <div class="analysis-details-container">
                                            <div class="analysis-card-details">
                                                <img class="analysis-details-image"
                                                    src="assets/images/analysis/rearfoot-width.png"
                                                    alt="{{ 'REARFOOT_WIDTH' | translate }}">
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.left.width.rearfoot }}cm</span>
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.right.width.rearfoot }}cm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'WEIGHT_DISTRIBUTION' | translate }}</strong>
                                        </h5>
                                        <div class="analysis-details-container">
                                            <div class="analysis-card-details">
                                                <img class="analysis-details-image"
                                                    src="assets/images/analysis/weight-distribution.png"
                                                    alt="{{ 'WEIGHT_DISTRIBUTION' | translate }}">
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                <span>{{
                                                    analysisComponent.feetAnalysis.left.stats.weightDistributionInPercentage
                                                    }}%</span>
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                <span>{{
                                                    analysisComponent.feetAnalysis.right.stats.weightDistributionInPercentage
                                                    }}%</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body-bottom">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'FOOT_AREA' | translate }}</strong>
                                        </h5>
                                        <div class="analysis-details-container">
                                            <div class="analysis-card-details">
                                                <img class="analysis-details-image"
                                                    src="assets/images/analysis/foot-area.png"
                                                    alt="{{ 'FOOT_AREA' | translate }}">
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'LEFT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.left.stats.footArea }}cm²</span>
                                            </div>
                                            <div class="analysis-card-details">
                                                <span><strong>{{ 'RIGHT' | translate }}</strong></span>
                                                <span>{{ analysisComponent.feetAnalysis.right.stats.footArea
                                                    }}cm²</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="premiumUser" class="graphs-container">
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.averagePressuresChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'AVERAGE_PRESSURE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.averagePressuresChartOptions.series"
                                            [chart]="analysisComponent.averagePressuresChartOptions.chart"
                                            [xaxis]="analysisComponent.averagePressuresChartOptions.xaxis"
                                            [yaxis]="analysisComponent.averagePressuresChartOptions.yaxis"
                                            [title]="analysisComponent.averagePressuresChartOptions.title"
                                            [tooltip]="analysisComponent.averagePressuresChartOptions.tooltip"
                                            [responsive]="analysisComponent.averagePressuresChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.maxPressuresChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'MAX_PRESSURE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.maxPressuresChartOptions.series"
                                            [chart]="analysisComponent.maxPressuresChartOptions.chart"
                                            [xaxis]="analysisComponent.maxPressuresChartOptions.xaxis"
                                            [yaxis]="analysisComponent.maxPressuresChartOptions.yaxis"
                                            [title]="analysisComponent.maxPressuresChartOptions.title"
                                            [tooltip]="analysisComponent.maxPressuresChartOptions.tooltip"
                                            [responsive]="analysisComponent.maxPressuresChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                </div>
                                <div *ngIf="!generatingPDF && premiumUser" class="generate-details-pdf">
                                    <span>{{ 'ANALYSIS_DETAILS' | translate }}</span>
                                    <button mat-raised-button class="pdf-special-button"
                                        (click)="generateAnalysisDetailsPDF()">
                                        <i class="pi pi-file-pdf"></i> </button>
                                </div>
                            </div>
                            <!-- Balance -->
                            <div *ngIf="analysis.type === 'Balance'">
                                <app-analysis #analysisComponent [showActions]="showActions"
                                    [analysis]="analysis"></app-analysis>
                                <div *ngIf="premiumUser" class="graphs-container">
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.leftCenterOfForceChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'LEFT_CENTER_OF_FORCE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.leftCenterOfForceChartOptions.series"
                                            [chart]="analysisComponent.leftCenterOfForceChartOptions.chart"
                                            [xaxis]="analysisComponent.leftCenterOfForceChartOptions.xaxis"
                                            [yaxis]="analysisComponent.leftCenterOfForceChartOptions.yaxis"
                                            [title]="analysisComponent.leftCenterOfForceChartOptions.title"
                                            [tooltip]="analysisComponent.leftCenterOfForceChartOptions.tooltip"
                                            [responsive]="analysisComponent.leftCenterOfForceChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.rightCenterOfForceChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'RIGHT_CENTER_OF_FORCE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.rightCenterOfForceChartOptions.series"
                                            [chart]="analysisComponent.rightCenterOfForceChartOptions.chart"
                                            [xaxis]="analysisComponent.rightCenterOfForceChartOptions.xaxis"
                                            [yaxis]="analysisComponent.rightCenterOfForceChartOptions.yaxis"
                                            [title]="analysisComponent.rightCenterOfForceChartOptions.title"
                                            [tooltip]="analysisComponent.rightCenterOfForceChartOptions.tooltip"
                                            [responsive]="analysisComponent.rightCenterOfForceChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.bodyChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'BODY_CENTER_OF_FORCE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.bodyChartOptions.series"
                                            [chart]="analysisComponent.bodyChartOptions.chart"
                                            [xaxis]="analysisComponent.bodyChartOptions.xaxis"
                                            [yaxis]="analysisComponent.bodyChartOptions.yaxis"
                                            [title]="analysisComponent.bodyChartOptions.title"
                                            [tooltip]="analysisComponent.bodyChartOptions.tooltip"
                                            [responsive]="analysisComponent.bodyChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                </div>
                                <div *ngIf="premiumUser" class="graphs-container">
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.lateralBalanceChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'LATERAL_BALANCE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.lateralBalanceChartOptions.series"
                                            [chart]="analysisComponent.lateralBalanceChartOptions.chart"
                                            [xaxis]="analysisComponent.lateralBalanceChartOptions.xaxis"
                                            [yaxis]="analysisComponent.lateralBalanceChartOptions.yaxis"
                                            [title]="analysisComponent.lateralBalanceChartOptions.title"
                                            [tooltip]="analysisComponent.lateralBalanceChartOptions.tooltip"
                                            [responsive]="analysisComponent.lateralBalanceChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                    <div class="data-label-container"
                                        *ngIf="analysisComponent && analysisComponent.frontBackBalanceChartOptions">
                                        <h5 class="btn-rounded btn-block analysis-card-body-top m-2 data-label badge">
                                            <strong>{{ 'FRONT_BACK_BALANCE' | translate }}</strong>
                                        </h5>
                                        <apx-chart [series]="analysisComponent.frontBackBalanceChartOptions.series"
                                            [chart]="analysisComponent.frontBackBalanceChartOptions.chart"
                                            [xaxis]="analysisComponent.frontBackBalanceChartOptions.xaxis"
                                            [yaxis]="analysisComponent.frontBackBalanceChartOptions.yaxis"
                                            [title]="analysisComponent.frontBackBalanceChartOptions.title"
                                            [tooltip]="analysisComponent.frontBackBalanceChartOptions.tooltip"
                                            [responsive]="analysisComponent.frontBackBalanceChartOptions.responsive">
                                        </apx-chart>
                                    </div>
                                </div>
                                <div *ngIf="!generatingPDF && premiumUser" class="generate-details-pdf">
                                    <span>{{ 'ANALYSIS_DETAILS' | translate }}</span>
                                    <button mat-raised-button type="button" class="pdf-special-button"
                                        (click)="generateAnalysisDetailsPDF()">
                                        <i class="pi pi-file-pdf"></i> </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Right side -->
    <div class="analysis-details-right-side">
        <mat-card>
            <mat-card-header style="margin-bottom: 30px;">
                <div class="pressures-title">
                    <mat-card-title>{{ 'PRESSURE_PLATE_ANALYSES' | translate }}</mat-card-title>
                    <button *ngIf="this.user.sensingtexManagerId" type="button" mat-raised-button color="primary"
                        (click)="startAnalysis()">{{
                        'NEW_ANALYSIS' | translate }}</button>
                </div>
            </mat-card-header>

            <div class="d-flex justify-content-center mb-10" *ngIf="isLoading">
                <div class="skeleton-card is-loading">
                    <div class="image"></div>
                    <div class="content">
                        <h2></h2>
                        <p></p>
                        <div class="d-flex justify-content-end w-100">
                            <h2></h2>
                        </div>
                    </div>
                </div>
            </div>

            <mat-card-content *ngIf="order?.sensingtexPatientId" class="p-3">
                <div class="analyses-container">
                    <ng-container *ngIf="patientAnalyses && patientAnalyses.length > 0; else noAnalyses">
                        <div *ngFor="let patientAnalysis of patientAnalyses">
                            <div class="mini-card" [ngClass]="{'active': patientAnalysis.id === analysisId}">
                                <div (click)="goToAnalysisDetails(orderId, patientAnalysis.id)">
                                    <div class="analysis-card-body-top">
                                        <app-analysis [showActions]="false" [analysis]="patientAnalysis"></app-analysis>
                                    </div>
                                    <div class="analysis-card-body-bottom">
                                        <h5
                                            class="btn-rounded btn-block analysis-card-body-top m-2 width-120 text-align-center badge">
                                            <strong>{{
                                                'ANALYSIS_TYPE.' + patientAnalysis.type | translate }}</strong>
                                        </h5>
                                        <h5 class="m-3"> {{ patientAnalysis.creationDate }}</h5>
                                    </div>
                                </div>
                                <div class="delete-button-container">
                                    <button type="button" class="delete-button"
                                        (click)="deleteAnalysis(patientAnalysis.id)"><strong>Remove</strong></button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noAnalyses>
                        <div class="mb-3">{{ isLoading ? 'Searching analyses...' : 'No analyses found.' }}</div>
                    </ng-template>
                </div>
            </mat-card-content>

            <p-dialog header="Select the type of analysis" [(visible)]="visible" [modal]="true"
                [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div *ngIf="connectedPlatform"
                    style="display: flex; justify-content: center; gap: 7px; align-items: baseline; margin-bottom: 15px;">
                    <p><strong>{{ 'CONNECTED_PLATFORM' | translate }}</strong>
                    </p>
                    <i class="pi pi-check-circle" style="color: green;"></i>
                </div>
                <div *ngIf="!connectedPlatform"
                    style="display: flex; justify-content: center; gap: 7px; align-items: baseline; margin-bottom: 15px;">
                    <p><strong>{{ 'PLATFORM_NOT_CONNECTED' | translate }}</strong>
                    </p>
                    <i class="pi pi-times" style="color: red;"></i>
                </div>
                <div class="flex-buttons">
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openStaticModal()">{{ 'STATIC' | translate }}</button>
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openDynamicModal()">{{ 'DYNAMIC' | translate }}</button>
                    <button type="button" [disabled]="!connectedPlatform" mat-raised-button color="primary"
                        (click)="openBalanceModal()">{{ 'BALANCE' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'STATIC_ANALYSIS_STEPS' | translate }}" [(visible)]="staticModalVisible" [modal]="true"
                [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/StaticAndBalanceAnalysis.png'" alt="static-analysis">
                    <h4>{{ 'STEP_ONE_STATIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_STATIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('static')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'DYNAMIC_ANALYSIS_STEPS' | translate }}" [(visible)]="dynamicModalVisible"
                [modal]="true" [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/DynamicAnalysis.gif'" alt="dynamic-analysis"
                        style="max-width: 200px;">
                    <h4>{{ 'STEP_ONE_DYNAMIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_DYNAMIC' | translate }}</h4>
                    <h4>{{ 'STEP_THREE_DYNAMIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('dynamic')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>

            <p-dialog header="{{ 'BALANCE_ANALYSIS_STEPS' | translate }}" [(visible)]="balanceModalVisible"
                [modal]="true" [breakpoints]="{'320px': '90vw'}" [style]="{width: '50vw'}">
                <div class="steps-info">
                    <img [src]="'assets/images/analysis/StaticAndBalanceAnalysis.png'" alt="balance-analysis">
                    <h4>{{ 'STEP_ONE_STATIC' | translate }}</h4>
                    <h4>{{ 'STEP_TWO_STATIC' | translate }}</h4>
                    <button type="button" mat-raised-button color="primary" (click)="requestAnalysis('balance')">{{
                        'READY' | translate }}</button>
                </div>
            </p-dialog>
        </mat-card>
    </div>
</div>